export default [
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/modules/erros/views/pages/NotFound.vue'),
    meta: {
      title: 'Não encontrado',
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/modules/erros/views/pages/Maintenance.vue'),
    meta: {
      title: 'Manutenção',
      unauthAllowed: true,
    },
  },
  {
    path: '/disconnected',
    name: 'disconnected',
    component: () => import('@/modules/erros/views/pages/Disconnected.vue'),
    meta: {
      title: 'Desconectado',
      unauthAllowed: true,
    },
  },
  {
    path: '/expired-session',
    name: 'expired-session',
    component: () => import('@/modules/erros/views/pages/ExpiredSession.vue'),
    meta: {
      title: 'Sessão expirada',
      unauthAllowed: true,
    },
  },
  {
    path: '/someting-wrong',
    name: 'something-wrong',
    component: () => import('@/modules/erros/views/pages/SomethingWrong.vue'),
    meta: {
      title: 'Erro desconhecido',
      unauthAllowed: true,
    },
  },
  {
    path: '/restrict-access',
    name: 'restrict-access',
    component: () => import('@/modules/erros/views/pages/RestrictAccess.vue'),
    meta: {
      title: 'Área restrita',
      unauthAllowed: true,
    },
  },
]
